module.exports = __webpack_public_path__ + "img/mile6m-m@1.44298b8d.jpg";